import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Preloader } from "./components/Preloader";
import { FilmGrain } from "./components/FilmGrain";
import { ParticleField } from "./components/ParticleField";
import { CustomCursor } from "./components/CustomCursor";
import { Header } from "./components/Header";
import Hero from "./components/sections/Hero";
import NFCSection from "./components/sections/NFCSection";
import CasosExito from "./components/sections/CasosExito";
import Footer from "./components/sections/Footer";
import { ChatWidget } from "./components/ChatWidget";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  const { pathname } = useLocation();

  // Guarantee the site always opens on the Hero: disable browser scroll
  // restoration and reset to top (except the /nfc deep link, handled below).
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    if (pathname !== "/nfc") window.scrollTo(0, 0);
  }, [pathname]);

  // /nfc deep link: land the visitor directly at the NFC cinematic section.
  useEffect(() => {
    if (pathname !== "/nfc") return;
    const t = setTimeout(() => {
      const el = document.querySelector('[data-testid="nfc-section"]');
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY;
        // Land 5% into the pinned range: intro label visible + pen emerging
        // (at exact section start the pen is still hidden in the background).
        const range = Math.max(el.offsetHeight - window.innerHeight, 0);
        window.scrollTo({ top: top + range * 0.05, behavior: "auto" });
      }
    }, 350);
    return () => clearTimeout(t);
  }, [pathname]);

  return (
    <div className="relative min-h-screen bg-black text-white" data-testid="home-page">
      <Preloader />
      <ParticleField />
      <FilmGrain />
      <CustomCursor />
      <Header />
      <main className="relative z-10">
        <Hero />
        <NFCSection />
        <CasosExito />
        <Footer />
      </main>
      <ChatWidget />
      <Toaster position="bottom-center" theme="dark" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nfc" element={<Home />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
